
import React from "react";
import SlideLayout from "../components/SlideLayout";
import AnimatedOrb from "../components/AnimatedOrb";
import { ShoppingBag, X, Menu, ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";

const ContactSlide = () => {
  return (
    <SlideLayout>
      <div className="space-y-8 relative flex flex-col items-center justify-center">
        <AnimatedOrb />
        
        <h3 className="text-3xl font-bold text-indigo-600 mb-4 font-poppins">Ready to Revolutionize Your Retail Business?</h3>
        
        {/* Chat Widget */}
        <div className="max-w-md w-full mx-auto bg-white rounded-3xl shadow-xl overflow-hidden">
          {/* Widget Header */}
          <div className="flex justify-between items-center p-4 border-b">
            <button className="p-2">
              <Menu className="h-5 w-5 text-violet-600" />
            </button>
            <button className="p-2">
              <X className="h-5 w-5 text-violet-600" />
            </button>
          </div>
          
          {/* Widget Body */}
          <div className="p-6 space-y-6">
            {/* Appella Logo & Greeting */}
            <div className="flex flex-col items-center space-y-4">
              <div className="bg-indigo-600 rounded-full p-4">
                <ShoppingBag className="h-8 w-8 text-white" />
              </div>
              <h2 className="text-4xl font-bold text-indigo-800">Good Afternoon!</h2>
            </div>
            
            {/* Chat Message */}
            <div className="flex items-start space-x-3">
              <div className="bg-indigo-600 rounded-full p-2 flex-shrink-0">
                <ShoppingBag className="h-6 w-6 text-white" />
              </div>
              <div className="space-y-1">
                <div className="flex items-center space-x-2">
                  <span className="font-medium text-indigo-700 font-playfair italic">Appella</span>
                  <span className="text-indigo-400">•</span>
                  <span className="text-indigo-400">AI Agent</span>
                  <span className="text-indigo-400">•</span>
                  <span className="text-indigo-400">2:55 PM</span>
                </div>
                <div className="bg-indigo-50 rounded-2xl p-4 max-w-xs">
                  <p className="text-indigo-800">Welcome! How can I help you today?</p>
                </div>
              </div>
            </div>
            
            {/* Quick Replies */}
            <div className="flex flex-wrap justify-end gap-2">
              <button className="bg-white border border-indigo-200 rounded-full px-5 py-2 text-sm text-indigo-800 hover:bg-indigo-50">
                Suprise me :)
              </button>
              <button className="bg-white border border-indigo-200 rounded-full px-5 py-2 text-sm text-indigo-800 hover:bg-indigo-50">
                What do you do?
              </button>
              <button className="bg-white border border-indigo-200 rounded-full px-5 py-2 text-sm text-indigo-800 hover:bg-indigo-50">
                What's new?
              </button>
            </div>
          </div>
          
          {/* Widget Footer */}
          <div className="p-4 border-t">
            <div className="relative">
              <input 
                type="text" 
                placeholder="Reply to Appella..." 
                className="w-full py-3 px-4 bg-indigo-50 rounded-full text-indigo-700 focus:outline-none"
              />
              <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-indigo-500 rounded-full p-2 hover:bg-indigo-600">
                <ArrowUp className="h-5 w-5 text-white" />
              </button>
            </div>
            
            {/* Powered by */}
            <div className="mt-4 text-center text-indigo-500 text-sm flex items-center justify-center gap-2">
              Powered by 
              <div className="flex items-center">
                <div className="bg-indigo-600 rounded-sm p-1 mr-1">
                  <ShoppingBag className="h-4 w-4 text-white" />
                </div>
                <span className="font-playfair italic">appella ai</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>
  );
};

export default ContactSlide;
